module.exports = __webpack_public_path__ + "img/big_eye_redchart02.2636ee46.jpg";